import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=5d2198aa&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=5d2198aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2198aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2198aa')) {
      api.createRecord('5d2198aa', component.options)
    } else {
      api.reload('5d2198aa', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=5d2198aa&scoped=true&", function () {
      api.rerender('5d2198aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/Navigation.vue"
export default component.exports